import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import { ClsLog } from "../../models/logging/clsLog";
import { RootState } from "../stores/store";

export interface FulfilledLog {
  endpointName: string;
  clsLog?: ClsLog;
}

export interface ErrorLog {
  errorMsg: string;
  clsLog?: ClsLog;
}

type SliceState = {
  fulfilledLog?: FulfilledLog;
  errorLog?: ErrorLog;
};

const initialState: SliceState = {
  fulfilledLog: undefined,
  errorLog: undefined,
};

const logSlice = createSlice({
  name: "logSlice",
  initialState,
  reducers: {
    addFulfilledLog(state, { payload }: PayloadAction<{ endpointName: string; clsLog: ClsLog }>) {
      const { endpointName, clsLog } = payload;
      state.fulfilledLog = { endpointName: endpointName, clsLog: clsLog };
    },
    clearFulfilledLog(state) {
      state.fulfilledLog = initialState.fulfilledLog;
    },
    addErrorLog(state, { payload }: PayloadAction<{ errorMsg: string; clsLog: ClsLog }>) {
      const { errorMsg, clsLog } = payload;
      state.errorLog = { errorMsg: errorMsg, clsLog: clsLog };
    },
    clearErrorLog(state) {
      state.errorLog = initialState.errorLog;
    },
  },
});

export const { addFulfilledLog, addErrorLog, clearFulfilledLog, clearErrorLog } = logSlice.actions;

export const selectFulfilledLog = (state: RootState) => state.logSlice.fulfilledLog;

export const selectErrorLog = (state: RootState) => state.logSlice.errorLog;

export const logSliceReducer = logSlice.reducer;
